export { default as StrainInfo } from './StrainInfo';
